<script>
import FormsActions from "@/components/forms/FormsActions";

export default {
  name: "FormLink",
  methods:{
    navigateTo(){
      if(this.id == null){
        FormsActions.showList(this.form);
      } else {
        FormsActions.editEntity(this.form, this.id);
      }
    }
  },
  props:{
    form: {default: ""},
    id: {default: ""},
    tabNameOrClazz: {default: ""},
    label: {default: ""}
  },
  data(){ return {
    linkLabel: this.label
  }}
}
</script>

<template>
  <button class="btn btn-link" @click="navigateTo"> {{linkLabel}} <slot >

  </slot></button>
</template>

<style scoped>

</style>